import index from './index';
import { Router } from '@/legacy/Router';

Router.get('deletion-log', index);
